/**
 * AUTH-1（2026-08-30・owner裁定）: Vercel Skew Protectionが自動保護しない
 * カスタムfetch（better-authクライアント・明示fetch）向けの共通ヘッダー生成。
 * 公式パターン: https://vercel.com/docs/skew-protection
 *
 * VERCEL_SKEW_PROTECTION_ENABLED/VERCEL_DEPLOYMENT_ID はローカル開発・CI・
 * 一部プレビューで未設定になり得る。未設定時はヘッダーを付与しない（機能無効化のno-op・
 * fail-closedではない＝検知不能を「保護不要」と誤判定して壊れることはない）。
 */
export function getSkewProtectionHeaders(): { 'x-deployment-id': string } | undefined {
  const enabled = process.env.VERCEL_SKEW_PROTECTION_ENABLED === '1'
  const deploymentId = process.env.VERCEL_DEPLOYMENT_ID
  if (!enabled || !deploymentId) return undefined
  return { 'x-deployment-id': deploymentId }
}
